var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header", { attrs: { model: _vm.model } }),
      _vm._v(" "),
      _vm._t("default", null, { model: _vm.model }),
      _vm._v(" "),
      _c("Footer", { attrs: { model: _vm.model } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }